import { fabric } from 'fabric';

import { Shapes } from '@shared/core';
import { FloorPlan, TableAttributes } from '@shared/floor-plan/models';
import { TableSizes } from '@shared/floor-plans';

export const CLONED_TABLE_ID = 'clonedTable';
export const CANVAS_GRID_CELL_SIZE = 15;
export const CANVAS_MIN_SHAPE_SIZE = CANVAS_GRID_CELL_SIZE * 4;
export const FLOORPLAN_GLOBAL_CLASSNAME = 'floorplan';

export interface FloorPlanForSwitcher extends FloorPlan {
  tablesCount: number;
}

export interface FloorPlanTableData {
  resourceId: string;
  floorPlanId: string;
}

export enum FloorPlanDraggable {
  tableOrObject = 'tableOrObject',
  canvas = 'canvas',
  party = 'party',
}

export interface FloorPlanDragState {
  moveX: number;
  moveY: number;
  startX: number;
  startY: number;
  offsetX: number;
  offsetY: number;
  target?: FloorPlanDraggable;
  dragCursor?: HTMLElement;
  dragStartedWithOffset?: boolean;
  dragStarted: boolean;
  dragTargetWidth?: number;
  partyId?: string;
}

export interface CanvasTableChildren {
  shape: Shapes;
  size: TableSizes;
  group: fabric.Group;
  shapeObject?: fabric.Object;
  nameText?: fabric.Text;
  capacityText?: fabric.Text;
  timeText?: fabric.Text;
}

export interface CanvasObjectMultiSelected {
  id: string;
  selected: boolean;
  isTable: boolean;
  resourceId?: string;
  isActionSourceUser: boolean;
}

export interface CanvasObjectSelected extends TableAttributes {
  id: string;
  isTable: boolean;
  sectionId?: string;
}

export interface CanvasColors {
  shapeStroke: string;
  shapeFill: string;
  textColor: string;
  dividerColor: string;
  backgroundColor: string;
  primaryColor: string;
}

export const CANVAS_LIGHT_THEME: CanvasColors = {
  shapeStroke: '#BFC5D9',
  shapeFill: '#FFFFFF',
  textColor: '#000',
  dividerColor: '#E4E7EB',
  backgroundColor: '#F5F9FC',
  primaryColor: '#000',
};

export const CANVAS_DARK_THEME: CanvasColors = {
  shapeStroke: '#4B5574',
  shapeFill: '#77889A',
  textColor: '#000',
  dividerColor: '#3D4252',
  backgroundColor: '#2E2E34',
  primaryColor: '#fff',
};

export const SHAPES_DIMENSIONS = {
  [Shapes.square]: {
    [TableSizes.small]: {
      width: 60,
      height: 60,
    },
    [TableSizes.medium]: {
      width: 75,
      height: 75,
    },
    [TableSizes.large]: {
      width: 90,
      height: 90,
    },
  },
  [Shapes.circle]: {
    [TableSizes.small]: {
      width: 60,
      height: 60,
    },
    [TableSizes.medium]: {
      width: 75,
      height: 75,
    },
    [TableSizes.large]: {
      width: 90,
      height: 90,
    },
  },
  [Shapes.rectangular]: {
    [TableSizes.small]: {
      width: 75,
      height: 60,
    },
    [TableSizes.medium]: {
      width: 90,
      height: 60,
    },
    [TableSizes.large]: {
      width: 115,
      height: 60,
    },
  },
};
